import Fetch, { V1, serializeQueryString } from 'Util/fetcher';

const ON_REQUEST_MUTUAL_FUND = 'ON_REQUEST_MUTUAL_FUND';
const ON_REQUEST_MUTUAL_FUND_FAILURE = 'ON_REQUEST_MUTUAL_FUND_FAILURE';
const ON_REQUEST_MUTUAL_FUND_SUCCESS = 'ON_REQUEST_MUTUAL_FUND_SUCCESS';

function onRequestMutualFund(categoryId) {
  return {
    type: ON_REQUEST_MUTUAL_FUND,
    meta: { categoryId }
  };
}

function onRequestMutualFundSuccess(payload, categoryId) {
  return {
    type: ON_REQUEST_MUTUAL_FUND_SUCCESS,
    payload,
    meta: { categoryId }
  };
}

function onRequestMutualFundFailure(payload, categoryId) {
  return {
    type: ON_REQUEST_MUTUAL_FUND_FAILURE,
    payload,
    meta: { categoryId }
  };
}

export const onDoRequestMutualFund = (payload, categoryId) => (dispatch) => {
  dispatch(onRequestMutualFund(categoryId));
  const qs = serializeQueryString(payload);
  Fetch.get(`${V1}mutualfund/fund-bundle/search/${qs}`).then((resp) => { 
    if (resp.ok) { 
      dispatch(onRequestMutualFundSuccess(resp.json, categoryId));
    } else {
      dispatch(onRequestMutualFundFailure(resp.json, categoryId));
    }
  }).catch((error) => {
    dispatch(onRequestMutualFundFailure(error.message, categoryId));
  });
};

const INITIAL_STATE = {
  mutualFundLoading: null,
  mutualFundData: null,
  mutualFundError: null,
};

const mutualFund = (state = INITIAL_STATE, { type, payload, meta } = {}) => {
  switch (type) {
    case ON_REQUEST_MUTUAL_FUND:
      return {
        ...state,
        mutualFundLoading: {
          ...state.mutualFundLoading,
          [meta.categoryId.toString()]: true
        },
      };
    case ON_REQUEST_MUTUAL_FUND_SUCCESS:
      return {
        ...state,
        mutualFundLoading: {
          ...state.mutualFundLoading,
          [meta.categoryId]: false
        },
        mutualFundData: {
          ...state.mutualFundData,
          [meta.categoryId.toString()]: payload
        },
        mutualFundError: {
          ...state.mutualFundError,
          [meta.categoryId.toString()]: null
        }
      };
    case ON_REQUEST_MUTUAL_FUND_FAILURE:
      return {
        ...state,
        mutualFundLoading: {
          ...state.mutualFundLoading,
          [meta.categoryId.toString()]: false
        },
        mutualFundData: {
          ...state.mutualFundData,
          [meta.categoryId.toString()]: null
        },
        mutualFundError: {
          ...state.mutualFundError,
          [meta.categoryId.toString()]: payload
        }
      };
    default:
      return state;
  }
};

export default mutualFund;
